<template>
  <div>
    <van-form ref="addForm" validate-trigger="onSubmit" class="formSty">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="基本信息" name="1">
          <!-- <van-field v-model="form.boName" label="商机名称" :rules="[{ required: true }]" placeholder="请填写商机名称" required /> -->
          <van-field readonly clickable v-model="form.custName" @click="isAdd?showCustList():''" label="客户" :rules="[{ required: true }]" placeholder="请选择客户" required/>
          <!-- <van-field readonly clickable v-model="form.boSourceName" label="商机来源" placeholder="请选择客户" required /> -->
          <van-field readonly clickable v-model="form.businessTypeName" @click="showPicker2" label="业务类型" :rules="[{ required: true }]" placeholder="请选择业务类型" required />
          <van-field readonly clickable v-model="form.possibilityName"  @click="showPicker('possibility')" label="意向度" placeholder="请选择意向度" required :rules="[{ required: true }]" />
          <!-- <van-field v-model="form.expectMoney" type="number" maxlength="8" label="合作金额(元)" placeholder="请填写合作金额(元)" required/> -->
          <!-- <van-field v-model="form.expectProfit" label="预期收益(元)" placeholder="请填写预期收益(元)" required /> -->
          <!-- <van-field v-model="form.saleExpect" readonly clickable name="calendar" label="销售预期" placeholder="点击选择日期" @click="handelDate()" required /> -->
          <!-- <van-field v-model="form.failFactors" label="失败关键因素"  placeholder="请填写失败关键因素" />
          <van-field v-model="form.successFactors" label="成功关键因素"  placeholder="请填写成功关键因素" /> -->
          <!-- <van-field readonly clickable v-model="form.distributeStatusName" @click="showPicker('distributeStatus')" label="分配状态" placeholder="请选择" required /> -->
          <!-- <van-field readonly clickable v-model="form.boStatusName" @click="showPicker('boStatus')" label="商机状态" placeholder="请选择" required />
          <van-field readonly clickable v-model="form.boSourceName" @click="showPicker('boSource')" label="商机来源" placeholder="请选择" required /> -->
          <van-field readonly clickable v-model="form.boStageIdName" @click="showPicker('boStageId')" label="商机阶段" placeholder="请选择商机阶段" required :rules="[{ required: true }]" />
         </van-collapse-item>
        <!-- <van-collapse-item :title="'产品报价'+(index+1)" :name="index+1" v-for="(pel,index) in form.quotedPriceList" :key="index">
          <van-field readonly clickable v-model="pel.productName" @click="showProList(index)" label="产品名称"  placeholder="请填写产品名称" />
          <van-field v-model="pel.amount" @input="getSum(pel,index)" label="数量" placeholder="请输入数量" />
          <van-field readonly clickable v-model="pel.unitName" @click="showPicker('unit',index)" label="单位" placeholder="请选择"  />
          <van-field v-model="pel.unitTprice" @input="getSum(pel,index)" label="单价(￥)" placeholder="请输入单价 (￥)" />
          <van-field v-model="pel.discountMoney" @input="getSum(pel,index)" label="折扣 (%)" placeholder="请输入折扣 (%)" />
          <van-field v-model="pel.percentTax" @input="getSum(pel,index)" label="税减百分比 (%)" placeholder="请输入税减百分比 (%)" />
          <van-field v-model="pel.directReduceTax" @input="getSum(pel,index)" label="税直接减(%)" placeholder="请输入税直接减 (%)" />
          <van-field v-model="pel.totalMoney" readonly label="总计(￥)" placeholder="请输入总计 (￥)" />
          <div class="link">
            <van-button class="linkaddBtn" round block type="primary" native-type="submit" size="small" @click="addPro">追加产品报价</van-button>
            <van-button class="linkaddBtn" v-if="index!=0" round block type="warning" native-type="submit" size="small" @click="delPro(index)">删除</van-button>
          </div>
        </van-collapse-item>
        <van-collapse-item :title="'人员配置'+(index+1)" :name="index+2" v-for="(pel,index) in form.userConList" :key="index+'01'">
          <van-field v-model="pel.title" label="标题" placeholder="请输入数量" />
          <van-field v-model="pel.amount" @input="getPersonSum(pel,index)" label="人员数量" placeholder="请输入人员数量" />
          <van-field v-model="pel.unitTprice" @input="getPersonSum(pel,index)" label="单价" placeholder="请输入单价" />
          <van-field v-model="pel.payMoney" readonly  label="金额(￥)" placeholder="请输入金额(￥)" />
          <div class="link">
            <van-button class="linkaddBtn" round block type="primary" native-type="submit" size="small" @click="addPerson">追加人员配置</van-button>
            <van-button class="linkaddBtn" v-if="index!=0" round block type="warning" native-type="submit" size="small" @click="delPerson(index)">删除</van-button>
          </div>
        </van-collapse-item> -->
      </van-collapse>
      <van-button v-preventReClick class="addBtn" round block type="info" native-type="submit" size="small" @click="handleAdd">保存</van-button>
    </van-form>
    <!-- 日期选择器 -->
    <van-calendar v-model="showDate" :min-date="minDate" type="single" @confirm="dateConfirm" />

    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
    <!-- <van-dialog v-model="showCust" class="cust" width="97%" title="选择客户" :beforeClose="beforeClose" :showConfirmButton = 'false' close-on-click-overlay>
      <van-list v-model="custloading" :finished="finished" finished-text="没有更多了" @load="custonLoad" v-if="custlist.length > 0 && custloading === false">
        <div>
          <van-cell v-for="(item,index) in custlist" :key="index" @click="selectCust(item)">
            <div class="flex-between">
              <div>
                <div class="custName-wrap"> <div class="custName"> {{ item.custName }} </div> </div>
                <div>
                  <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.custType">{{ formatHandel("custType",item.custType) }}</van-tag>
                  <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.custSource">{{ formatHandel("custSource",item.custSource) }}</van-tag>
                  <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.custStatus">{{ formatHandel("custStatus",item.custStatus) }}</van-tag>
                </div>
              </div>
            </div>
          </van-cell>
        </div>
      </van-list>
    </van-dialog> -->
    <van-dialog v-model="showPro" class="cust" width="97%" title="选择产品" :beforeClose="probeforeClose" :showConfirmButton = 'false' close-on-click-overlay>
      <van-list v-model="proloading" :finished="profinished" finished-text="没有更多了" @load="proonLoad" v-if="prolist.length > 0 && proloading === false">
        <div>
          <van-cell v-for="(item,index) in prolist" :key="index" @click="selectPro(item,index)">
            <div class="flex-between">
              <div>
                <div class="custName-wrap"> <div class="custName"> {{ item.productName }} </div> </div>
                <div>
                  <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.productType">{{ formatHandel("productType",item.productType) }}</van-tag>
                  <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" >{{ item.unitTprice }}/{{ item.unit==1?'小时':'天' }}</van-tag>
                </div>
              </div>
            </div>
          </van-cell>
        </div>
      </van-list>
    </van-dialog>

    <van-popup v-model="showServiceTree" position="bottom">
      <van-cascader title="请选择业务类型" :options="serviceTypeTreeList" :field-names="fieldNames" @change="serviceChange"  @close="showServiceTree = false" @finish="onFinishTree" />
    </van-popup>
    <select-customer :show='select_show' @handleCancel='handleCancel' @beforeClose='selectBeforeClose'></select-customer>
  </div>
</template>

<script>
import { addBo, getBo, listProduct, getAllStage, updateBo } from '@/api/scrm/mycust'
import { getDicts } from '@/api/system/dict/data'
import { getdistrict } from '@/api/system/district.js'
import { businessTypeList } from '@/api/admi/dept'
import { areaList } from '@vant/area-data'
import { Toast, Cascader } from 'vant'
import SelectCustomer from '@/components/common/SelectCustomer'

export default {
  name: 'boAddInfos',
  components: {
    [Toast.name]: Toast,
    vanCascader: Cascader,
    SelectCustomer
  },
  data() {
    return {
      select_show: false,
      activeNames: ['1'],
      isEmpty: false,
      isAdd: true,
      showServiceTree: false,
      serviceTypeTreeList: [],
      fieldNames: {
        text: 'businessTypeName',
        value: 'businessTypeId'
      },
      picker: {
        visible: false,
        visibleIndustry: false,
        title: '',
        columns: [],
        formKey: ''
      },
      address: '',
      minDate: new Date(2010, 0, 1),
      loading: false,
      custloading: false,
      proloading: false,
      finished: false,
      profinished: false,
      custlist: [],
      prolist: [],
      show: false,
      type: 'add',
      showFilterPop: false,
      showDate: false,
      showCust: false,
      showPro: false,
      searchValue: '',
      boList: [],
      options: {
        // 商机类型字典
        boTypeOptions: this.$store.state.dictOptions.crmBoType || [],
        // 业务类型树选项
        // businessTypeOptions: this.$store.state.dictOptions.businessTypeTree|| [],
        // 商机来源字典
        boSourceOptions: this.$store.state.dictOptions.boSource || [],
        // 商机状态
        boStatusOptions: this.$store.state.dictOptions.boStatus || [],
        // 性别状态字典
        sexOptions: this.$store.state.dictOptions.sex || [],
        // 客户类型字典
        custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
        // 客户来源字典
        custSourceOptions: this.$store.state.dictOptions.custSource || [],
        // 客户状态
        custStatusOptions: this.$store.state.dictOptions.custStatus || []
      },
      form: {
        boId: null,
        boName: this.$route.query.boName,
        boType: this.$route.query.boType,
        boTypeName: this.$route.query.boTypeName,
        distributeStatus: 1, // 已分配
        province: '',
        city: '',
        area: '',
        lng: '',
        lat: '',
        latLong: '',
        boAddress: '',
        userConList: [{
        }],
        quotedPriceList: [{
          productId: '',
          productName: '',
          unit: '',
          unitTprice: ''
        }]
      },
      queryParams: {},
      areaList: areaList,
      index: null
    }
  },
  created() {
    this.getOptions()
    console.log(this.$route.query)
    if (this.$route.query.custName && this.$route.query.custId) {
      this.form.custId = this.$route.query.custId
      this.form.custName = this.$route.query.custName
      this.form.boSource = this.$route.query.custSource
    }
    if (this.$route.query.boId) {
      this.getBoInfo(this.$route.query.boId)
      this.isAdd = false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 计算预期收益
    sumExpectProfit() {
      const expectMoney = this.addForm.expectMoney || 0
      const possibility = this.addForm.possibility || 0
      const total = expectMoney * possibility
      this.addForm.expectProfit = total.toFixed(2)
    },
    async init() {
      // 修改主体框架标题
      document.title = 'SCRM-新建商机'
    },
    async getBoInfo(boId) {
      const res = await getBo(boId)
      if (res.code === 200) {
        this.form = res.data || []
        console.log(res.data)
        this.setName('distributeStatus')
        this.setName('boStatus')
        this.setName('boSource')
        this.setName('possibility')
        this.setName('boStageId')
        if (this.form.quotedPriceList) {
          for (let i = 0; i < this.form.quotedPriceList.length; i++) {
            const element = this.form.quotedPriceList[i]
            element.unitName = element.unit == 1 ? '小时' : '天'
          }
        }
      }
    },
    setName(type) {
      const optionItem = type + 'Options'
      const obj = this.options[optionItem].find((item, index) => {
        if (type == 'boStageId') {
          return item.boStageId == this.form[type]
        } else {
          return item.dictValue == this.form[type]
        }
      })
      if (obj != null) {
        const name = type + 'Name'
        if (type == 'boStageId') {
          this.form[name] = obj.stageName + '(' + obj.stageValue + '%)'
        } else {
          this.form[name] = obj.dictLabel
        }
      }
    },
    getOptions() {
      getAllStage().then(response => {
        this.options.boStageIdOptions = response.rows || []
      })
      getDicts('crm_mybo_type').then(res => {
        this.options.boTypeOptions = res.data
      })
      getDicts('crm_scale').then(res => {
        this.options.scaleOptions = res.data
      })
      getDicts('crm_bo_status').then(res => {
        this.options.boStatusOptions = res.data
      })
      getDicts('crm_acquire_way').then(res => {
        this.options.acquireWayOptions = res.data
      })
      getDicts('crm_unit_nature').then(res => {
        this.options.unitNatureOptions = res.data
      })
      getDicts('crm_bo_level').then(res => {
        this.options.boLevelOptions = res.data
      })
      getDicts('crm_call_name').then(res => {
        this.options.callNameOptions = res.data
      })
      getDicts('crm_bo_source').then(res => {
        this.options.boSourceOptions = res.data
      })
      // 证件类型
      getDicts('crm_ide_type').then(res => {
        this.options.ideTypeOptions = res.data
      })
      // 亲密度
      getDicts('crm_intimacy').then(res => {
        this.options.intimacyOptions = res.data
      })
      // 性别
      getDicts('sys_user_sex').then(res => {
        this.options.sexOptions = res.data
      })
      // 产品类型
      getDicts('product_type').then(res => {
        this.options.productTypeOptions = res.data
      })
      this.getDicts('unit_type').then(res => {
        this.options.unitOptions = res.data
      })
      // 分配状态
      this.getDicts('cms_distribute_status').then(res => {
        this.options.distributeStatusOptions = this.setDictToInt(res)
      })
      // 意向度
      this.getDicts('crm_bo_possibility ').then(res => {
        this.options.possibilityOptions = res.data
      })
    },
    formatHandel(type, value) {
      const optionItem = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[optionItem], value)
      } else {
        return ''
      }
    },
    async showPicker2() {
      if (this.serviceTypeTreeList.length == 0) {
        // 获取获取业务类型
        businessTypeList({ pageNum: 1, pageSize: 500 }).then((response) => {
          if (response.code === 200) {
            this.serviceTypeTreeList = this.getData(response.rows)
          }
        })
      }
      this.showServiceTree = true
    },
    showPicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.picker.formKey = type
      const optionItem = type + 'Options'
      // if(type == "businessTypeId"){
      //   this.picker.columns = this.options.businessTypeOptions.map(ele => this.businessNormalizer(ele))
      // }else
      if (type == 'boStageId') {
        this.picker.columns = this.options.boStageIdOptions.map(ele => this.boStageNormalizer(ele))
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
      }

      this.picker.visible = true
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      if (this.index || this.index == 0) {
        this.form.quotedPriceList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
        this.form.quotedPriceList[this.index][name] = this.options[optionItem][key].dictLabel
      } else {
        // if(this.picker.formKey == "businessTypeId"){
        //   if (value.length == 2) {
        //     if (value[1].length > 0) {
        //       this.form.businessTypeName = value[0] + '/' + value[1]
        //       let obj = this.options.businessTypeOptions.find(item => item.businessTypeName === value[0])
        //       if (obj != null) {
        //         this.form.businessTypeId = obj.children.find(item => item.businessTypeName === value[1]).businessTypeId
        //       }
        //     }
        //   } else {
        //     this.form.businessTypeName = value[0]
        //     let obj = this.options.businessTypeOptions.find(item => item.businessTypeName === value[0])
        //     if (obj != null) {
        //       this.form.businessTypeId = obj.businessTypeId
        //     }
        //   }
        // }else
        if (this.picker.formKey == 'boStageId') {
          this.form[this.picker.formKey] = this.options[optionItem][key].boStageId
          this.form[name] = this.options[optionItem][key].stageName + '(' + this.options[optionItem][key].stageValue + '%)'
        } else {
          this.form[this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form[name] = this.options[optionItem][key].dictLabel
        }
      }
      this.picker.visible = false
    },
    serviceChange(obj) {
      if (obj.selectedOptions[3]) {
        if (obj.selectedOptions[3].businessTypeName == '腾讯') {
          this.form.businessTypeId = obj.value
          this.form.businessTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
        }
      }
    },
    onFinishTree(obj) {
      this.form.businessTypeId = obj.value
      this.form.businessTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
      this.showServiceTree = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    pickerChange() { },
    showCustList() {
      this.select_show = true
      // this.showCust = true
      // this.custlist = []
      // this.handleCustList()
    },
    handleCancel() {
      this.select_show = false
    },
    selectBeforeClose(val) {
      this.form.custId = val.custId
      this.form.custName = val.custName
      this.form.boSource = val.custSource
      // this.form.boSourceName = this.options.boSourceOptions.find(item => item.dictValue == val.custSource).dictLabel
      this.select_show = false
    },
    showProList(index) {
      this.index = index
      this.showPro = true
      this.prolist = []
      this.handleProList()
    },
    beforeClose() {
      this.showCust = false
    },
    probeforeClose() {
      this.showPro = false
    },
    selectCust(item) {
      this.form.custId = item.custId
      this.form.custName = item.custName
      this.showCust = false
    },
    selectPro(item) {
      this.form.quotedPriceList[this.index].productId = item.productId
      this.form.quotedPriceList[this.index].productName = item.productName
      this.showPro = false
    },
    addBo() {
      this.show = true
    },
    addPerson() {
      const peo = {}
      this.form.userConList.push(peo)
    },
    delPerson(item) {
      this.form.userConList.splice(item, 1)
    },
    addPro() {
      const peo = {}
      this.form.quotedPriceList.push(peo)
    },
    delPro(item) {
      this.form.quotedPriceList.splice(item, 1)
    },
    handelDate() {
      this.showDate = true
    },
    async handleAdd() {
      await this.$refs.addForm.validate()
      this.form.boName = this.form.custName + '【' + this.form.businessTypeName + '】'
      if (this.$route.query.boId) {
        updateBo(this.form).then((response) => {
          Toast.success('修改商机成功!')
          setTimeout(() => {
            this.$router.go(-1)
          }, 500)
        })
      } else {
        addBo(this.form).then((response) => {
          Toast.success('新增商机成功!')
          setTimeout(() => {
            this.$router.go(-1)
          }, 500)
        })
      }
    },
    async handleCustList() {
      // this.custloading = true;
      // const res = await listCust({});
      // if (res.code === 200) {
      //   if (res.rows.length === 0) {
      //     this.isEmpty = true
      //   }
      //   this.custlist = this.custlist.concat(...res.rows);
      //   this.finished = this.custlist.length >= res.total;
      //   this.custloading = false;
      // }
    },
    custonLoad() {
      this.handleCustList()
    },
    async handleProList() {
      this.proloading = true
      const res = await listProduct({})
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        }
        this.prolist = this.prolist.concat(...res.rows)
        this.profinished = this.prolist.length >= res.total
        this.proloading = false
      }
    },
    proonLoad() {
      this.handleProList()
    },
    /** 转换地区数据结构 */
    areaNormalizer(node) {
      const arr = []
      if (node.children && node.children.length) {
        for (const i in node.children) {
          const item = {
            id: node.children[i].areaId,
            text: node.children[i].areaName
          }
          arr.push(item)
        }
      }

      return {
        id: node.areaId,
        text: node.areaName,
        children: arr
      }
    },
    // /** 转换业务类型数据结构 */
    // businessNormalizer(node) {
    //   let arr = []
    //   if (node.children && node.children.length) {
    //     for (let i in node.children) {
    //       let item = {
    //         id: node.children[i].businessTypeId,
    //         text: node.children[i].businessTypeName
    //       }
    //       arr.push(item)
    //     }
    //   }
    //   return {
    //     id: node.businessTypeId,
    //     text: node.businessTypeName,
    //     children: arr
    //   };
    // },
    // 去除树形数据的空children
    removeEmptyChildren(node) {
      node.forEach(item => {
        if ('children' in item && item.children.length === 0) {
          delete item.children
        } else if ('children' in item && item.children.length) {
          this.removeEmptyChildren(item.children)
        }
      })
      return node
    },
    /** 转换业务类型数据结构 */
    getData (arr) {
      // 利用两层filter实现
      const data = arr.filter(item => {
        item.children = arr.filter(e => {
          return item.businessTypeId === e.parentId
        })
        return !item.parentId
      })
      return this.removeEmptyChildren(data)
    },
    boStageNormalizer(node) {
      return {
        id: node.boStageId,
        text: node.stageName + '(' + node.stageValue + '%)'
      }
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    dateConfirm(data) {
      this.form.saleExpect = this.formatDate(data)
      this.showDate = false
      this.minDate = data
    },
    // 返回布尔值
    beforeRead(file) {
      if (
        file.type !== 'image/jpeg' &&
        file.type !== 'image/png' &&
        file.type !== 'image/jpg'
      ) {
        Toast('请上传 jpg 、jpeg、png 格式图片')
        return false
      }
      return true
    },
    handleContractRemove(file) {
      let picture = this.form.contractImg
      console.log(file.url)
      if (picture.indexOf(file.url) == 0) {
        if (picture.indexOf(',') == -1) {
          picture = null
        } else {
          picture = picture.replace(file.url + ',', '')
        }
      } else {
        picture = picture.replace(',' + file.url, '')
      }
      this.form.contractImg = picture
      console.log(this.form.contractImg)
      this.pictureList = []
      if (this.form.contractImg != null && this.form.contractImg.length > 0) {
        const payCaptures = this.form.contractImg.split(',')
        payCaptures.forEach((element) => {
          this.pictureList.push({
            url: element
          })
        })
      }
      // this.deleteFileList.push(file.url);
      // console.log(this.deleteFileList);
    },
    // uploadContractPictureFiles(file) {
    //   console.log(file)
    //   const _file = file.file
    //   // 通过 FormData 对象上传文件
    //   var formData = new FormData()
    //   formData.append('file', _file)

    //   ucloudUpFileToContract(formData)
    //     .then((res) => {
    //       console.log('_RequestUploads_', res)
    //       if (res.code === 200) {
    //         // this.form.contractImg = res.url;
    //         let picture = this.form.contractImg
    //         if (picture != null && picture.length > 0) {
    //           picture += ',' + res.url
    //         } else {
    //           picture = res.url
    //         }
    //         this.form.contractImg = picture
    //         const payCaptures = this.form.contractImg.split(',')
    //         this.pictureList = []
    //         payCaptures.forEach((element) => {
    //           this.pictureList.push({
    //             url: element
    //           })
    //         })
    //         Toast.success(res.msg)
    //       } else {
    //         Toast.fail('res.msg')
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    // },
    // 省市区
    getdistrict(parent, type) {
      getdistrict({ parent: parent }).then((res) => {
        if (type == 1) {
          const province = res.rows
          for (let i = 0; i < province.length; i++) {
            const item = province[i]

            this.areaList.province_list[item.id] = item.fullname
          }
        } else if (type == 2) {
          const city = res.rows
          for (let i = 0; i < city.length; i++) {
            const item = city[i]
            this.areaList.city_list[item.id] = item.fullname
          }
        } else if (type == 3) {
          const county = res.rows
          for (let i = 0; i < county.length; i++) {
            const item = county[i]
            this.areaList.county_list[item.id] = item.fullname
          }
        }
      })
    }
    // getSum(e, index) {
    //   let amount, unitTprice, directReduceTax, discountMoney, percentTax
    //   // 数量
    //   amount = e.amount || 0
    //   // 单价
    //   unitTprice = e.unitTprice || 0
    //   // 折扣
    //   discountMoney = e.discountMoney || 1
    //   // 税减百分比
    //   percentTax = e.percentTax || 1
    //   // 税直接减
    //   directReduceTax = e.directReduceTax || 0
    //   const total = ((amount * unitTprice) * discountMoney) * percentTax - directReduceTax
    //   this.form.quotedPriceList[index].totalMoney = total.toFixed(2)
    // },
    // getPersonSum(e, index) {
    //   let amount, unitTprice
    //   // 数量
    //   amount = e.amount || 0
    //   // 单价
    //   unitTprice = e.unitTprice || 0

    //   const total = amount * unitTprice

    //   this.form.userConList[index].payMoney = total.toFixed(2)
    // }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");

.cust /deep/.van-dialog__content {
  overflow: auto;
  height: 13rem;
}
.cust /deep/ .van-list {
    padding-top: 0.1rem;
    padding-bottom: 2.13333rem;
}
</style>
